import React from 'react';
import { LogOut } from 'lucide-react';
import { logoutUser } from '../lib/auth';

interface LogoutButtonProps {
  onLogout?: () => void;
  className?: string;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ onLogout, className = '' }) => {
  const handleLogout = () => {
    logoutUser();
    if (onLogout) {
      onLogout();
    }
    window.location.href = '/';
  };

  return (
    <button
      onClick={handleLogout}
      className={`flex items-center space-x-2 text-red-600 hover:text-red-800 transition-colors ${className}`}
    >
      <LogOut className="w-4 h-4" />
      <span>Se déconnecter</span>
    </button>
  );
};

export default LogoutButton;